import { EuiPageTemplate, EuiLoadingChart } from "@inscopix/ideas-eui";

export const CreatePersonalSpaceLoading = () => {
  return (
    <EuiPageTemplate.EmptyPrompt
      title={<span>One moment please...</span>}
      icon={<EuiLoadingChart size="xl" mono />}
    />
  );
};
